import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAdmin } from '../context/AuthContext';

/**
 * AdminRoute — wrap `/admin/*` routes so non-admins silently bounce to `/`.
 *
 * Behaviour (per Phase 3 brief):
 *   • While auth is still bootstrapping → render nothing (avoids a flash of
 *     admin UI before the role check resolves).
 *   • Authenticated user with `app_metadata.role !== 'admin'` → `<Navigate to="/" replace />`.
 *     No toast, no error page — silent redirect.
 *   • Admin → render children.
 *
 * Note: this is a UI convenience only. The backend re-validates every
 * `/api/admin/*` call against the same JWT claim — a tampered SPA could
 * never bypass server-side gating.
 */
const AdminRoute = ({ children }) => {
  const { isAdmin, loading } = useIsAdmin();

  if (loading) return null;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
};

export default AdminRoute;
